import React, { useState, useEffect } from 'react';
import './LandingPage.css';

// Set your fixed launch date here (e.g., June 5, 2026, 00:00:00)
const TARGET_DATE = new Date('2026-06-06T00:00:00');

const LandingPage = () => {
  const [timeLeft, setTimeLeft] = useState(TARGET_DATE - new Date());

  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(TARGET_DATE - new Date());
    }, 1000);
    return () => clearInterval(timer);
  }, []);

  const days = Math.floor(timeLeft / (1000 * 60 * 60 * 24));
  const hours = Math.floor((timeLeft / (1000 * 60 * 60)) % 24);
  const minutes = Math.floor((timeLeft / (1000 * 60)) % 60);
  const seconds = Math.floor((timeLeft / 1000) % 60);

  return (
    <div className="LandingPage">
      <h1>Website will be live after</h1>
      <div>
        {days} days {hours}h {minutes}m {seconds}s
      </div>
      <div className="contact-note">
        <h6>
          For any queries, contact{' '}
          <a
            href="mailto:iam@ankurgogoi.com"
            style={{ color: '#fff', textDecoration: 'underline', pointerEvents: 'auto' }}
          >
            iam@ankurgogoi.com
          </a>
        </h6>
      </div>
    </div>
  );
};

export default LandingPage;